import { Button, IconButton, Modal, Typography } from "@mui/material";
import { CrossIcon } from "../Plans/icons/GPTIcons/CrossIcon";
import { capitalizeFirstChar } from "../../helpers";

type WarningModalProps = {
  open: boolean;
  handleExit: () => void;
  handleCloseWarning: () => void;
  mainText: string;
  subText?: string;
  warningType?: string;
};
const WarningModal = ({ open, handleExit, handleCloseWarning, mainText, subText = "Your changes will be lost if you close this window now.", warningType = "Return" }: WarningModalProps) => {
  return (
    <Modal open={open}>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow w-modal-mobile sm:w-modal-md md:w-modal-lg rounded-lg p-6 bg-white text-mui-black-87 dark:bg-background/paper-elevation-16 dark:text-white">
        <div className="flex flex-col gap-y-6">
          <div className="flex justify-between items-center">
            <Typography variant="h6/medium-500" className="text-mui-black-87 dark:text-white">
              {mainText}
            </Typography>
            <IconButton
              size="small"
              onClick={handleCloseWarning}
              className="cross-icon"
            >
              <CrossIcon className="fill-current" />
            </IconButton>
          </div>

          <>
            <div className="text-sm">
              {subText}
            </div>
            <div className="flex flex-col gap-y-4 md:flex-row gap-x-6 justify-center">
              <Button
                variant="contained"
                color="error"
                size="large"
                fullWidth
                className="!bg-error-main !normal-case"
                onClick={handleExit}
              >
                Close & Discard Changes
              </Button>
              <Button
                variant="outlined"
                color="inherit"
                size="large"
                fullWidth
                className="button-outlined"
                onClick={handleCloseWarning}
              >
                Return to
                {" "}
                {capitalizeFirstChar(warningType)}
              </Button>
            </div>
          </>
        </div>
      </div>
    </Modal>
  );
};

export default WarningModal;
